
      var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgClear = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 12,
  height: 12,
  textRendering: "geometricPrecision",
  viewBox: "0 0 12 12"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
  id: "clear_cbcec397824b9ffd__a",
  width: 12,
  height: 12,
  x: 0,
  y: 0,
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("image", {
  xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAMAAABhq6zVAAAAUVBMVEVMaXH////////////////////////////////////////////////////////////////////////////////////////////////////////JzkR1AAAAG3RSTlMAf4EP5n6ABgXnB4J77eqDb31H5EjfTnx6T8UNYSo0AAAACXBIWXMAAAPoAAAD6AG1e1JrAAAAXUlEQVR42i2Oiw6AIAhFryUBmdn79f8fmqKMjXMGA4CNUaPPGZ0Zp/0AghbjwT9SSrbMk9iA09A1Lr1Zl8aQFOdubEyeBq0mqydmMpPb22rSAFznUo/S19sXdeeLH+R2Awa5yPQ1AAAAAElFTkSuQmCC",
  width: 12,
  height: 12,
  href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAMAAABhq6zVAAAAUVBMVEVMaXH////////////////////////////////////////////////////////////////////////////////////////////////////////JzkR1AAAAG3RSTlMAf4EP5n6ABgXnB4J77eqDb31H5EjfTnx6T8UNYSo0AAAACXBIWXMAAAPoAAAD6AG1e1JrAAAAXUlEQVR42i2Oiw6AIAhFryUBmdn79f8fmqKMjXMGA4CNUaPPGZ0Zp/0AghbjwT9SSrbMk9iA09A1Lr1Zl8aQFOdubEyeBq0mqydmMpPb22rSAFznUo/S19sXdeeLH+R2Awa5yPQ1AAAAAElFTkSuQmCC",
  preserveAspectRatio: "none",
  style: {
    imageRendering: "crisp-edges"
  }
}))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "var(--theme-primary, #810ea9)",
  mask: "url(#clear_cbcec397824b9ffd__a)",
  shapeRendering: "crispEdges",
  d: "M0 0h12v12H0z"
})));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"12\" height=\"12\" text-rendering=\"geometricPrecision\" viewBox=\"0 0 12 12\"><defs><image xlink:href=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAMAAABhq6zVAAAAb1BMVEVMaXGQAPySDP+5Lv+QAPqRAPqRAPynNf++Pf+QAPqSAPuSAPyOAPqPAPqRAPyQAPmTAP2SAP6PAPmRAPuQAPqRAPuUAPyOAPqNAPiQAPqSAPuQAPmRAPqRAPqRAPuOAPmRAPyOAPmQAPqOAPuMAPgdZoGiAAAAJXRSTlMAfg8H5oB/BgXne4F+gn3tR0jkfIF6f2+Bb9/q7eqD506DxU+CiGXaoQAAAAlwSFlzAAAD6AAAA+gBtXtSawAAAGZJREFUeNotjosOgzAIRW9dKzCrbu7lW+f2/99oS0tIOCcQALgRUhQh21KN1u4O1BKNnH1xLMECX1kH3lL3mWNv2j6Zwd95eV4ye+udVGrcWENk1PhhdbWRP7CPQzpqjkK/SDt/OAEjIQPnG9haCgAAAABJRU5ErkJggg==\" id=\"convert2-source\" width=\"12\" height=\"12\" href=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAMAAABhq6zVAAAAb1BMVEVMaXGQAPySDP+5Lv+QAPqRAPqRAPynNf++Pf+QAPqSAPuSAPyOAPqPAPqRAPyQAPmTAP2SAP6PAPmRAPuQAPqRAPuUAPyOAPqNAPiQAPqSAPuQAPmRAPqRAPqRAPuOAPmRAPyOAPmQAPqOAPuMAPgdZoGiAAAAJXRSTlMAfg8H5oB/BgXne4F+gn3tR0jkfIF6f2+Bb9/q7eqD506DxU+CiGXaoQAAAAlwSFlzAAAD6AAAA+gBtXtSawAAAGZJREFUeNotjosOgzAIRW9dKzCrbu7lW+f2/99oS0tIOCcQALgRUhQh21KN1u4O1BKNnH1xLMECX1kH3lL3mWNv2j6Zwd95eV4ye+udVGrcWENk1PhhdbWRP7CPQzpqjkK/SDt/OAEjIQPnG9haCgAAAABJRU5ErkJggg==\" preserveAspectRatio=\"none\"/><mask id=\"layer-0\" width=\"12\" height=\"12\" x=\"0\" y=\"0\" mask-type=\"alpha\" maskUnits=\"userSpaceOnUse\"><image xlink:href=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAMAAABhq6zVAAAAUVBMVEVMaXH////////////////////////////////////////////////////////////////////////////////////////////////////////JzkR1AAAAG3RSTlMAf4EP5n6ABgXnB4J77eqDb31H5EjfTnx6T8UNYSo0AAAACXBIWXMAAAPoAAAD6AG1e1JrAAAAXUlEQVR42i2Oiw6AIAhFryUBmdn79f8fmqKMjXMGA4CNUaPPGZ0Zp/0AghbjwT9SSrbMk9iA09A1Lr1Zl8aQFOdubEyeBq0mqydmMpPb22rSAFznUo/S19sXdeeLH+R2Awa5yPQ1AAAAAElFTkSuQmCC\" width=\"12\" height=\"12\" href=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAMAAABhq6zVAAAAUVBMVEVMaXH////////////////////////////////////////////////////////////////////////////////////////////////////////JzkR1AAAAG3RSTlMAf4EP5n6ABgXnB4J77eqDb31H5EjfTnx6T8UNYSo0AAAACXBIWXMAAAPoAAAD6AG1e1JrAAAAXUlEQVR42i2Oiw6AIAhFryUBmdn79f8fmqKMjXMGA4CNUaPPGZ0Zp/0AghbjwT9SSrbMk9iA09A1Lr1Zl8aQFOdubEyeBq0mqydmMpPb22rSAFznUo/S19sXdeeLH+R2Awa5yPQ1AAAAAElFTkSuQmCC\" preserveAspectRatio=\"none\" style=\"image-rendering:crisp-edges\"/></mask></defs><rect width=\"12\" height=\"12\" fill=\"var(--theme-primary, #810ea9)\" mask=\"url(#layer-0)\" shape-rendering=\"crispEdges\"/></svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/clear.cbcec397824b9ffdee3ad31085670ef8.svg"),
        {
          React: SvgClear,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      